import type { Theme } from '@mui/material/styles';
import { lightTheme, darkTheme } from './theme';

export type ThemeMode = 'light' | 'dark';

/**
 * Get theme based on mode
 * @param mode - Theme mode ('light' or 'dark')
 * @returns MUI Theme object
 */
export const getTheme = (mode: ThemeMode): Theme => {
  return mode === 'light' ? lightTheme : darkTheme;
};

export { lightTheme, darkTheme };
export type { Theme };
